import _defineProperty from "/buddy/remotehvac-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { unit } from '@ant-design/cssinjs';
var genStepsProgressDotStyle = function genStepsProgressDotStyle(token) {
  var componentCls = token.componentCls,
    descriptionMaxWidth = token.descriptionMaxWidth,
    lineHeight = token.lineHeight,
    dotCurrentSize = token.dotCurrentSize,
    dotSize = token.dotSize,
    motionDurationSlow = token.motionDurationSlow;
  return _defineProperty(_defineProperty({}, "&".concat(componentCls, "-dot, &").concat(componentCls, "-dot").concat(componentCls, "-small"), _defineProperty({}, "".concat(componentCls, "-item"), _defineProperty(_defineProperty({
    '&-title': {
      lineHeight: lineHeight
    },
    '&-tail': {
      // Math.floor((token.size - token.lineWidth * 3) / 2)
      top: token.calc(token.dotSize).sub(token.calc(token.lineWidth).mul(3).equal()).div(2).equal(),
      width: '100%',
      marginTop: 0,
      marginBottom: 0,
      marginInline: "".concat(unit(token.calc(descriptionMaxWidth).div(2).equal()), " 0"),
      padding: 0,
      '&::after': {
        width: "calc(100% - ".concat(unit(token.calc(token.marginSM).mul(2).equal()), ")"),
        height: token.calc(token.lineWidth).mul(3).equal(),
        marginInlineStart: token.marginSM
      }
    },
    '&-icon': _defineProperty({
      width: dotSize,
      height: dotSize,
      marginInlineStart: token.calc(token.descriptionMaxWidth).sub(dotSize).div(2).equal(),
      paddingInlineEnd: 0,
      lineHeight: "".concat(unit(dotSize)),
      background: 'transparent',
      border: 0
    }, "".concat(componentCls, "-icon-dot"), {
      position: 'relative',
      float: 'left',
      width: '100%',
      height: '100%',
      borderRadius: 100,
      // very large number
      transition: "all ".concat(motionDurationSlow),
      /* expand hover area */
      '&::after': {
        position: 'absolute',
        top: token.calc(token.marginSM).mul(-1).equal(),
        insetInlineStart: token.calc(dotSize).sub(token.calc(token.controlHeightLG).mul(1.5).equal()).div(2).equal(),
        width: token.calc(token.controlHeightLG).mul(1.5).equal(),
        height: token.controlHeight,
        background: 'transparent',
        content: '""'
      }
    }),
    '&-content': {
      width: descriptionMaxWidth
    }
  }, "&-process ".concat(componentCls, "-item-icon"), {
    position: 'relative',
    top: token.calc(dotSize).sub(dotCurrentSize).div(2).equal(),
    width: dotCurrentSize,
    height: dotCurrentSize,
    lineHeight: "".concat(unit(dotCurrentSize)),
    background: 'none',
    marginInlineStart: token.calc(token.descriptionMaxWidth).sub(dotCurrentSize).div(2).equal()
  }), "&-process ".concat(componentCls, "-icon"), _defineProperty({}, "&:first-child ".concat(componentCls, "-icon-dot"), {
    insetInlineStart: 0
  })))), "&".concat(componentCls, "-vertical").concat(componentCls, "-dot"), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(componentCls, "-item-icon"), {
    marginTop: token.calc(token.controlHeight).sub(dotSize).div(2).equal(),
    marginInlineStart: 0,
    background: 'none'
  }), "".concat(componentCls, "-item-process ").concat(componentCls, "-item-icon"), {
    marginTop: token.calc(token.controlHeight).sub(dotCurrentSize).div(2).equal(),
    top: 0,
    insetInlineStart: token.calc(dotSize).sub(dotCurrentSize).div(2).equal(),
    marginInlineStart: 0
  }), "".concat(componentCls, "-item > ").concat(componentCls, "-item-container > ").concat(componentCls, "-item-tail"), {
    top: token.calc(token.controlHeight).sub(dotSize).div(2).equal(),
    insetInlineStart: 0,
    margin: 0,
    padding: "".concat(unit(token.calc(dotSize).add(token.paddingXS).equal()), " 0 ").concat(unit(token.paddingXS)),
    '&::after': {
      marginInlineStart: token.calc(dotSize).sub(token.lineWidth).div(2).equal()
    }
  }), "&".concat(componentCls, "-small"), _defineProperty(_defineProperty(_defineProperty({}, "".concat(componentCls, "-item-icon"), {
    marginTop: token.calc(token.controlHeightSM).sub(dotSize).div(2).equal()
  }), "".concat(componentCls, "-item-process ").concat(componentCls, "-item-icon"), {
    marginTop: token.calc(token.controlHeightSM).sub(dotCurrentSize).div(2).equal()
  }), "".concat(componentCls, "-item > ").concat(componentCls, "-item-container > ").concat(componentCls, "-item-tail"), {
    top: token.calc(token.controlHeightSM).sub(dotSize).div(2).equal()
  })), "".concat(componentCls, "-item:first-child ").concat(componentCls, "-icon-dot"), {
    insetInlineStart: 0
  }), "".concat(componentCls, "-item-content"), {
    width: 'inherit'
  }));
};
export default genStepsProgressDotStyle;